module.exports = __webpack_public_path__ + "img/28_46.cf8888e3.png";